import type { PropsWithChildren } from 'react';

import type { HistogramAnnotationsProps } from '../../components/annotations-histogram/types.js';

/** HistogramChart Annotations subcomponent props */
export const Annotations = (
  props: PropsWithChildren<HistogramAnnotationsProps>,
) => null;

Annotations['displayName'] = 'HistogramAnnotations.Annotations';
